export default __webpack_public_path__ + "static/media/SJA1370.34I-41602_-24881_0.0eb3d9ae.jpg";